import ServiceBase from "base/baseService"

export default class EsferaService extends ServiceBase {

    title = "Esfera"
    pluralTitle = "Esferas"
    url = '/cadastro/fiscal/esfera'
    frontUrl = '/cadastro/fiscal/esfera'
    frontUrlList = '/cadastro/fiscal/esferalist'
    primaryKey = 'codigo_esf'

    prepareToFront(data = {}) {
        data.codigo_esf = data?.codigo_esf || ''
        data.descricao_esf = data?.descricao_esf || ''
        return data
    }

    prepareToSave({ data }) {
        if ('meta' in data) delete data.meta
        return data
    }
}
